import {CsvConfigJsonResult, SynopticElementStateCsvConfiguration} from '../synoptic-configuration-csv-types';
import {isSensorIdentifier} from './isSensorIdentifier';

export function isSynopticElementStateCsvConfiguration(obj: SynopticElementStateCsvConfiguration, stateArgTypeGuard: (stateArg: any) => CsvConfigJsonResult): CsvConfigJsonResult {
  let errors = [];
  let valid = true;

  if (typeof obj !== 'object' ||
    obj === null) {
    errors.push({code: 'invalidState', key: ''});
    return {result: false, errors: errors};
  }
  if (obj.sensorIdentifier === undefined) {
    errors.push({code: 'notExist', key: 'sensorIdentifier'});
    valid = false;
  } else {
    const resultIsSensorIdentifier = isSensorIdentifier(obj.sensorIdentifier);
    if (!resultIsSensorIdentifier.result) {
      errors = [...errors, ...resultIsSensorIdentifier.errors];
      valid = false;
    }
  }

  if (obj.args === undefined) {
    errors.push({code: 'notExist', key: 'args'});
    valid = false;
  } else {
    const resultStateArgTypeGuard = stateArgTypeGuard(obj.args);
    if (!resultStateArgTypeGuard.result) {
      errors = [...errors, ...resultStateArgTypeGuard.errors];
      valid = false;
    }
  }

  return {result: valid, errors: errors};
}
